const error = {
  general: {
    403: 'errorHandlerGeneralStatusCode403'
  },
  firmwareDelete: {
    default: 'errorHandlerFirmwareDeleteDefault'
  },
  firmwareUpload: {
    default: 'errorHandlerFirmwareUploadDefault'
  },
  informationModelDelete: {
    428: 'errorHandlerInformationModelDeleteStatusCode428',
    default: 'errorHandlerInformationModelDeleteDefault'
  },
  informationModelUpload: {
    400: 'The information model limit reached.',
    428: 'errorHandlerInformationModelUploadStatusCode428',
    default: 'errorHandlerInformationModelUploadDefault'
  },
  informationModelImagesUpload: {
    default: 'errorHandlerInformationModelImagesUploadDefault'
  },
  legal: {
    default: 'errorHandlerLegalDefault'
  },
  notifications: {
    default: 'errorHandlerNotificationsDefault'
  },
  notificationsDelete: {
    default: 'errorHandlerNotificationsDeleteDefault'
  },
  notificationsEdit: {
    default: 'errorHandlerNotificationsEditDefault'
  },
  solutionStatusTest: {
    default: 'errorHandlerSolutionStatusTestDefault'
  },
  timeline: {
    default: 'errorHandlerTimelineDefault'
  },
  timelineModel: {
    default: 'errorHandlerTimelineModelDefault'
  },
  theme: {
    default: 'errorHandlerThemeDefault'
  },
  themeLegal: {
    default: 'errorHandlerThemeLegalDefault'
  },
  themeView: {
    default: 'errorHandlerThemeViewDefault'
  },
  user: {
    default: 'errorHandlerUserDefault'
  }
}

export default function (component, status) {
  return error[component][status] || error[component].default
}



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js